import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { OperationConfirmationState } from '../../../../common/validations'
import { ContractType } from '../../../../common/types'
import { resolveOperationConfirmationHeadingText } from '../utils/resolveOperationConfirmationHeadingText'
import { resolveOperationConfirmationIllustration } from '../utils/resolveOperationConfirmationIllustration'
import { resolveOperationConfirmationStateText } from '../utils/resolveOperationConfirmationStateText'

import { ResidentAppIllustration } from 'components/ResidentAppIllustration'
import Success from 'components/Success'

interface TerminateContractSuccessProps {
  contractType: ContractType
}

export const TerminateContractSuccess: React.FC<
  TerminateContractSuccessProps
> = ({ contractType }) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const [params] = useSearchParams()

  const state = params.get('state') as OperationConfirmationState

  return (
    <Success
      illustration={
        <ResidentAppIllustration
          name={resolveOperationConfirmationIllustration(state)}
          alt={t('common:alt.illustration')}
          className="-ml-2"
        />
      }
      heading={resolveOperationConfirmationHeadingText(state)}
      text={resolveOperationConfirmationStateText(state, contractType)}
    />
  )
}
